import { useEffect, useState } from "react";
import { opApi } from "@/lib/api";

const CELLS = [
  ["today", "Bookings today", "not cancelled"],
  ["upcoming_week", "Upcoming", "rest of this week"],
  ["no_shows_30d", "No-shows", "last 30 days"],
  ["completed_today", "Completed", "today"],
];

// Header numbers for appointment dashboards (replaces the order stats).
export function BookingStats() {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => opApi.get("/tenant/booking-stats").then(({ data }) => setS(data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="border border-border mb-6 bg-card grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-border" data-testid="booking-stats-card">
      {CELLS.map(([k, label, sub]) => (
        <div key={k} className="px-5 py-3.5" data-testid={`booking-stat-${k}`}>
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</div>
          <div className={`mt-1 font-mono font-bold text-2xl ${k === "no_shows_30d" && s?.[k] ? "text-destructive" : ""}`}>{s ? s[k] : "—"}</div>
          <div className="text-[10px] text-muted-foreground">{sub}</div>
        </div>
      ))}
    </div>
  );
}
